import { signal } from '@angular/core';

export interface ThemeState {
    isFullscreen: boolean;
    leftSideHidden: boolean;
}

const initialState: ThemeState = {
    isFullscreen: false,
    leftSideHidden: false,
};

export const themeState = signal<ThemeState>(initialState);

export const toggleFullscreen = () => {
    themeState.update(state => ({
        ...state,
        isFullscreen: !state.isFullscreen,
    }));
};

export const toggleLeftSide = () => {
    themeState.update(state => ({
        ...state,
        leftSideHidden: !state.leftSideHidden,
    }));
};
